<script setup lang="ts">
// #737/#739: / からは show-heading / show-game-like=false / show-images=false で呼ぶ
// （見出し「Code & Magic とは」あり、「ゲーム仕立てだから〜」と画面キャプチャ4枚は隠す）。
// 既定値は #737 以前の旧 / 相当だが、現時点で default 系呼び出し元はない（消したくなったら消して良い）。
interface Props {
  showHeading?: boolean
  showGameLike?: boolean
  showImages?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  showHeading: false,
  showGameLike: true,
  showImages: true,
})
</script>

<template>
  <div class="centered-area">
    <!-- <h2>
          <v-img src="@/assets/images/code_and_magic_black_textlogo.svg" alt="Code & Magic" width="6em" inline
            style="vertical-align: middle;" />
          について
        </h2>
        <p>
          <TextCo> （コードアンドマジック）は、つくって、あそんで、仲間とつながれる、<v-tooltip
            class="tooltip"
            aria-label="インディゲームと呼ぶには小粒な、自分でつくって遊べるくらいのゲームをハンドメイドゲームと呼んでいます"
          >
            <template #activator="{ props }">
              <span class="tooltip" v-bind="props">ハンドメイドゲーム</span>
            </template><span>インディゲームと呼ぶには小粒な<br>自分でつくって遊べるくらいのゲームを<br>ハンドメイドゲームと呼んでいます</span>
</v-tooltip>好きのためのサービスです。
</p>
<ul>
  <li>昔、プログラミングで遊んでいた</li>
  <li>もう一度、気軽にゲームを作りたい</li>
  <li>子どもに「楽しいプログラミング」を見せたい</li>
  <li>正解よりも、試行錯誤を楽しみたい</li>
</ul>
<p>そんなあなたにおススメです！。</p>
<div class="caution-area">
  ※業務効率化や資格取得を目的としたプログラミング学習サービスではありません。そのようなサービスをお探しの方は<a target="_blank"
    href="https://www.google.com/search?q=%E6%A5%AD%E5%8B%99%E5%8A%B9%E7%8E%87%E5%8C%96%E3%82%84%E8%B3%87%E6%A0%BC%E5%8F%96%E5%BE%97%E3%82%92%E7%9B%AE%E7%9A%84%E3%81%A8%E3%81%97%E3%81%9F%E3%83%97%E3%83%AD%E3%82%B0%E3%83%A9%E3%83%9F%E3%83%B3%E3%82%B0%E5%AD%A6%E7%BF%92%E3%82%B5%E3%83%BC%E3%83%93%E3%82%B9&rlz=1C1ONGR_jaJP1033JP1033&oq=%E6%A5%AD%E5%8B%99%E5%8A%B9%E7%8E%87%E5%8C%96%E3%82%84%E8%B3%87%E6%A0%BC%E5%8F%96%E5%BE%97%E3%82%92%E7%9B%AE%E7%9A%84%E3%81%A8%E3%81%97%E3%81%9F%E3%83%97%E3%83%AD%E3%82%B0%E3%83%A9%E3%83%9F%E3%83%B3%E3%82%B0%E5%AD%A6%E7%BF%92%E3%82%B5%E3%83%BC%E3%83%93%E3%82%B9">こちら</a>。
</div> -->
    <h2 v-if="props.showHeading">
      <TextCodeAndMagic /> とは
    </h2>
    <p>
      <TextCodeAndMagic /> （コードアンドマジック）は、読者の誰もが明日の作者であるという1980年代のマイコン雑誌の投稿文化を、大人気プログラミング言語 <strong>Python</strong> × 国産レトロゲームライブラリ <strong>Pyxel</strong> で再構成した、つくって、あそんで、仲間とつながれる、懐かしくて新しいサービスです。
    </p>
    <template v-if="props.showGameLike">
      <h3 class="text-center mt-4">
        ゲーム仕立てだから、楽しんで続けられます！
      </h3>
      <p>
        <TextCodeAndMagic /> は、それ自体がゲーム仕立てになっています。
      </p>
      <p>
        みなさんは、プログラミングが魔法（ゲーム）を生み出す謎の大陸「エンコーディア」に集まった冒険者となり、一緒に楽しみましょう。
      </p>
    </template>
    <template v-if="props.showImages">
      <div class="mt-8" />
      <v-container fluid>
        <v-row>
          <v-col
            cols="12"
            sm="3"
          >
            <v-img
              src="@/assets/images/landing/AboutCodeAndMagic01.webp"
              alt="Code & Magic の画面1"
              width="100%"
              class="shadowed"
            />
          </v-col>
          <!-- <v-col cols="12" sm="4">
              <v-img src="@/assets/images/landing/EnjoyGames.webp" alt="Code & Magic の画面（ゲーム画面）" width="100%"
                class="shadowed" />
            </v-col> -->
          <v-col
            cols="12"
            sm="3"
          >
            <v-img
              src="@/assets/images/landing/AboutCodeAndMagic02.webp"
              alt="Code & Magic の画面2"
              width="100%"
              class="shadowed"
            />
          </v-col>
          <v-col
            cols="12"
            sm="3"
          >
            <v-img
              src="@/assets/images/landing/AboutCodeAndMagic_Cradle.webp"
              alt="Code & Magic の画面（羽根筆のゆりかご）"
              width="100%"
              class="shadowed"
            />
          </v-col>
          <v-col
            cols="12"
            sm="3"
          >
            <v-img
              src="@/assets/images/landing/AboutCodeAndMagic_Dialog.webp"
              alt="Code & Magic の画面（イベントダイアログ）"
              width="100%"
              class="shadowed"
            />
          </v-col>
        </v-row>
      </v-container>
    </template>
  </div>
</template>

<style scoped>
section.black {
  background-color: var(--landing-color-dark-bg);
  color: white;
}

.centered-area {
  width: 100%;
  height: 100%;
  max-width: var(--landing-max-width);
  margin: auto;
  padding: var(--landing-gutter);
}

.centered-area h2 {
  font-size: var(--landing-h2-size);
  font-weight: 700;
  text-align: center;
  margin-top: 0;
  margin-bottom: 0.5em;
}

.centered-area h3 {
  font-family: 'Noto Sans JP', sans-serif;
  font-size: var(--landing-h3-size);
  font-weight: 500;
  text-align: center;
  margin-bottom: 0.5em;
}

.centered-area p {
  margin-bottom: 0.5em;
}

.centered-area ul {
  padding-left: 1.5em;
}

section div.rounded-area {
  margin: 0 0.5em;
  padding: var(--landing-rounded-padding);

  color: var(--landing-color-text-dark);
  background-color: #ffffff;
  border-radius: var(--landing-radius);
}

.rounded-area h3 {
  /* color: #333333; */
  font-size: 2em;
  text-align: center;
  margin-bottom: 0.7em;
}
</style>
